function applyColumnsDisplayed(columnDefs, columnsDisplayed) {
  
  if (!columnsDisplayed || columnsDisplayed.length===0) {
    return (columnDefs);
  }

  // validate the column displayed, list and ignore it if contains bogus column names
  // next update should clear out state
  for ( let i=0; i<columnsDisplayed.length; i++) {
    if(getColumnDefIndexByName(columnDefs, columnsDisplayed[i])<0) {
      return (columnDefs);
    }
  }

  columnDefs.forEach( (columnDef) => {
    if (columnsDisplayed.indexOf(columnDef.name) >= 0) {
      columnDef.options={...columnDef.options, ...{ display: true }};
    } else {
      columnDef.options={...columnDef.options, ...{ display: false }};
    }
  });
  
  return columnDefs;
}

export function compileColumnDefs(baseDefs, overrideDefs) {
  let orderedDefs=[];
  overrideDefs.forEach( (overrideDef) => {
    let baseDefIndex=getColumnDefIndexByName(baseDefs,overrideDef.name);
    if(baseDefIndex>=0) {
      orderedDefs.push(mergeColumnDef(baseDefs[baseDefIndex], overrideDef));
    } else {
      orderedDefs.push(overrideDef);
    }
  });
  baseDefs.forEach( (baseDef) => {
    let compiledDefIndex=getColumnDefIndexByName(orderedDefs,baseDef.name);
    if(compiledDefIndex<0) {
      orderedDefs.push(baseDef);
    }
  });
  return orderedDefs;
}

function getColumnDefIndexByName(columnDefs, name) {
  let result=-1;
  for(var i=0; i<columnDefs.length; i++) {
    if(columnDefs[i].name===name) {
      result=i;
      break;
    }
  }
  return result;
}

export function getEffectiveColumnDefs(baseColumnDefs, overrideColumnDefs, columnsDisplayed) {
  const overriddenColumnDefs = compileColumnDefs(baseColumnDefs, overrideColumnDefs);
  return applyColumnsDisplayed(overriddenColumnDefs, columnsDisplayed);
}

export function getColumnsDisplayed(baseColumnDefs, overriddenColumnDefs, columnsDisplayed) {
  let currentColumnDefs=getEffectiveColumnDefs(baseColumnDefs, overriddenColumnDefs, columnsDisplayed);
  let newColumnsDisplayed=new Set([]);
  currentColumnDefs.forEach( (columnDef) => {
    if (!columnDef.options || (typeof columnDef.options.display==='undefined') || columnDef.options.display===true) {
      newColumnsDisplayed.add(columnDef.name);
    }
  });
  return Array.from(newColumnsDisplayed);
}

function mergeColumnDef(target, source) {
  if(source.label) {
    target.label=source.label;
  }
  if(source.options) {
    target.options={...target.options, ...source.options};
  }
  return target;
}
